import * as Sentry from "@sentry/nextjs";

type SentryExportName = "captureException" | "captureMessage";

const sentryRuntime = Sentry as Record<string, unknown> & {
  default?: Record<string, unknown>;
};

const getSentryExport = <Name extends SentryExportName>(name: Name) => {
  const exportedValue = sentryRuntime[name] ?? sentryRuntime.default?.[name];

  return exportedValue as (typeof Sentry)[Name];
};

export const captureException: typeof Sentry.captureException = (...args) => {
  const captureExceptionImpl = getSentryExport("captureException");

  return captureExceptionImpl(...args);
};

export const captureMessage: typeof Sentry.captureMessage = (...args) => {
  const captureMessageImpl = getSentryExport("captureMessage");

  return captureMessageImpl(...args);
};
